module.exports = __webpack_public_path__ + "static/couture02-sq-256b7fa0fce4f0f37cf861222ecd076c.png";